

export function getMinMaxRevenue(data: { revenue: number }[]) {
  if (!data || data.length === 0) return { min: 0, max: 0 };

  const values = data.map((d) => d.revenue);
  const min = Math.min(...values);
  const max = Math.max(...values);

  return {
    min: min < 0 ? Math.max(Math.floor(min / 5000) * 5000, -10000) : 0,
    max: Math.ceil(max / 5000) * 5000,
  };
}
